"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StatusIndicatorIcon = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _layout = require("../layout");

var _utils = require("../utils");

var _StatusIndicatorText = _interopRequireDefault(require("./StatusIndicatorText"));

var _interfaces = require("./interfaces");

var _propTypes = require("./propTypes");

var _sizeConfiguration = require("./sizeConfiguration");

var _statusIndicatorConstants = require("./statusIndicatorConstants");

var _core = require("@emotion/core");

var _excluded = ["status", "messageText", "iconAltText", "iconAriaHidden", "size", "colorScheme", "width", "id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Align to the center of the first line of text by making the height of the
// wrapper equal to the line height of the text, and centering the icon vertically
// in the wrapper.
var StatusIndicatorIconWrapper = (0, _context.styledWithTheme)('div', {
  shouldForwardProp: (0, _utils.filterProps)(['fontSize'])
})(function (_ref) {
  var theme = _ref.theme,
      fontSize = _ref.fontSize;
  return {
    display: 'flex',
    alignItems: 'center',
    // Line height is specified as unitless so it must be multiplied by the font size
    // to get the absolute value.
    height: "calc(".concat(theme.selectors.lineHeight(fontSize), " * ").concat(theme.selectors.fontSize(fontSize), ")")
  };
});

var StatusIndicatorIcon = function StatusIndicatorIcon(_ref2) {
  var status = _ref2.status,
      iconColorProp = _ref2.iconColor,
      iconAltText = _ref2.iconAltText,
      iconAriaHidden = _ref2.iconAriaHidden,
      size = _ref2.size;
  if (!size || !status) return null;
  var iconComponent = _sizeConfiguration.iconComponents[size][status];

  if (!iconComponent) {
    return null;
  }

  var iconColor = !!iconColorProp ? {
    color: iconColorProp
  } : {};
  var titleProp = iconAltText === undefined ? {} : {
    title: iconAltText
  };
  return (0, _core.jsx)(StatusIndicatorIconWrapper, _sizeConfiguration.textSizeConstants[size], iconComponent(_objectSpread(_objectSpread(_objectSpread({}, titleProp), iconColor), {}, {
    'aria-hidden': iconAriaHidden
  })));
};

exports.StatusIndicatorIcon = StatusIndicatorIcon;
var StatusIndicatorDefaultProps = {
  size: _interfaces.StatusIndicatorSize.Small,
  colorScheme: _interfaces.StatusIndicatorColorScheme.Default
};

var StatusIndicator = function StatusIndicator(_ref3) {
  var status = _ref3.status,
      messageText = _ref3.messageText,
      iconAltText = _ref3.iconAltText,
      iconAriaHidden = _ref3.iconAriaHidden,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? StatusIndicatorDefaultProps.size : _ref3$size,
      _ref3$colorScheme = _ref3.colorScheme,
      colorScheme = _ref3$colorScheme === void 0 ? StatusIndicatorDefaultProps.colorScheme : _ref3$colorScheme,
      width = _ref3.width,
      id = _ref3.id,
      props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return (0, _core.jsx)(_layout.Row, (0, _extends2.default)({
    "data-test-component": "StatusIndicator",
    alignItems: "flex-start",
    minWidth: _statusIndicatorConstants.STATUS_INDICATOR_MIN_WIDTH,
    width: width,
    gridGap: _statusIndicatorConstants.STATUS_INDICATOR_GAP,
    id: id
  }, props), !!status && status !== _interfaces.Status.Neutral && (0, _core.jsx)(StatusIndicatorIcon, {
    size: size,
    status: status,
    iconColor: colorScheme === _interfaces.StatusIndicatorColorScheme.Inverted ? 'neutral0' : undefined,
    iconAltText: iconAltText,
    iconAriaHidden: iconAriaHidden
  }), (0, _core.jsx)(_StatusIndicatorText.default, (0, _extends2.default)({
    color: colorScheme === _interfaces.StatusIndicatorColorScheme.Default ? 'neutral70' : 'neutral0'
  }, _sizeConfiguration.textSizeConstants[size]), messageText));
};

StatusIndicator.defaultProps = _objectSpread({}, StatusIndicatorDefaultProps);
StatusIndicator.displayName = 'StatusIndicator';
var StatusIndicatorWithDocs = (0, _stencilReactDesc.describe)(StatusIndicator).description('Visual representation of status.');
StatusIndicatorWithDocs.propTypes = _propTypes.propTypes;
var _default = StatusIndicatorWithDocs;
exports.default = _default;